import { Button, Col, Row } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { useContext, useEffect, useState } from 'react';
import LabelRequired from 'src/app/modules/component/LabelRequired';
import ProvisonalDiagnosis from '../../../components/ProvisonalDiagnosis';
import TextField from 'src/app/modules/component/TextField';
import { PhanHeTiepDonContext } from '../../../contexts/PhanHeTiepDonContext';
import ICD10 from '../../../components/ICD10';
import { IDanhSachDanhMuc } from 'src/app/modules/phan-he-tiep-nhan-thanh-toan/models/TiepDonModel';
import { getIndexedDBItem } from 'src/app/modules/utils/IndexedDB';
import { KEY_DS_DANH_MUC_TIEP_DON } from 'src/app/modules/utils/Constant';

const ChanDoanChuyenTuyen = () => {
    const { benhNhanInfo } = useContext(PhanHeTiepDonContext);
    const { values, errors, touched, setValues, setFieldValue } = useFormikContext<any>();

    const [shouldOpenModalICD10, setShouldOpenModalICD10] = useState<boolean>(false);
    const [shouldOpenModalSelectICD10, setShouldOpenModalSelectICD10] = useState<boolean>(false);
    const [listICD10, setListICD10] = useState<any>([]);

    const [listComorbidity, setListComorbidity] = useState<any[]>([]);

    useEffect(() => {
        handleGetListICD10();
    }, []);

    const handleGetListICD10 = async () => {
        try {
            const res: IDanhSachDanhMuc = await getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON);
            setListICD10(res?.listICD10 || []);
        } catch (error) {
            console.error(error);
        }
    };

    const handleChangeICD10 = (data: any) => {
        setValues({
            ...values,
            ...data,
        });
    };

    return (
        <>
            <div className="spaces mt-8 mb-n2 d-flex flex-row justify-content-between">
                <LabelRequired label="Chẩn đoán ban đầu" className="min-w-125px" />
                <Button
                    className="bg-white spaces mb-2 px-2"
                    onClick={() => setShouldOpenModalSelectICD10(true)}
                >
                    <u className="fw-bold color-17A2B8 fs-13px">Chọn bệnh</u>
                </Button>
            </div>
            <Row className="align-items-center">
                <ProvisonalDiagnosis
                    encounterDiagnosisValues={values}
                    encounterDiagnosisErrors={errors}
                    encounterDiagnosisTouched={touched}
                    benhNhanInfo={benhNhanInfo}
                    listComorbidity={listComorbidity}
                    setListComorbidity={setListComorbidity}
                    onChange={handleChangeICD10}
                    icd10Field="htDiagnosis"
                    comorbidityField="htComorbidity"
                    handleChangeEncounterDiagnosis={setFieldValue}
                />
            </Row>
            <Row className="mt-3">
                <Col xs={12}>
                    <LabelRequired label="Bệnh kèm theo" />
                    <TextField
                        className="resize-none"
                        as="textarea"
                        rows="3"
                        name="htComorbidity"
                        value={values?.htComorbidity || ''}
                        readOnlyText
                    />
                </Col>
            </Row>
            <ICD10
		        shouldOpenModalICD10={shouldOpenModalICD10}
		        setShouldOpenModalICD10={setShouldOpenModalICD10}
		        shouldOpenModalSelectICD10={shouldOpenModalSelectICD10}
		        setShouldOpenModalSelectICD10={setShouldOpenModalSelectICD10}
		        listICD10={listICD10}
		        listComorbidity={listComorbidity}
		        setListComorbidity={setListComorbidity}
		        selectionModeICD10="radio"
		        data={values}
		        icd10Field="htDiagnosis"
		        comorbidityField="htComorbidity"
		        onChange={handleChangeICD10}
		    />
        </>
    );
};

export default ChanDoanChuyenTuyen;
